/**
 * Utility functions for item handling
 */

/**
 * Get the item name based on the current language
 * @param {Object} item - The item object with name, name_ar, name_fr properties
 * @param {string} currentLanguage - The current language code (en, ar, fr)
 * @returns {string} The item name in the requested language
 */
export const getItemName = (item, currentLanguage = 'en') => {
  if (!item) return '';
  
  switch (currentLanguage) {
    case 'ar':
      return item.name_ar || item.name || '';
    case 'fr':
      return item.name_fr || item.name || '';
    case 'en':
    default:
      return item.name || '';
  }
};

/**
 * Get the item description based on the current language
 * @param {Object} item - The item object with description properties
 * @param {string} currentLanguage - The current language code (en, ar, fr)
 * @returns {string} The item description in the requested language
 */
export const getItemDescription = (item, currentLanguage = 'en') => {
  if (!item) return '';
  
  switch (currentLanguage) {
    case 'ar':
      return item.description_ar || item.description || '';
    case 'fr':
      return item.description_fr || item.description || '';
    case 'en':
    default:
      return item.description || '';
  }
};

/**
 * Get the batch item name based on the current language
 * @param {Object} batch - The batch object with item_name, item_name_ar, item_name_fr properties
 * @param {string} currentLanguage - The current language code (en, ar, fr)
 * @returns {string} The item name in the requested language
 */
export const getBatchItemName = (batch, currentLanguage = 'en') => {
  if (!batch) return '';
  
  switch (currentLanguage) {
    case 'ar':
      return batch.item_name_ar || batch.item_name || '';
    case 'fr':
      return batch.item_name_fr || batch.item_name || '';
    case 'en':
    default:
      return batch.item_name || '';
  }
};
